var React = require('react');

function ChatSendIconWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.296 13.94a.5.5 0 0 0-.38.35L4 20.88a1 1 0 0 0 1.42.908l17.434-8.067a1 1 0 0 0 .06-1.785L5.48 2.403A1 1 0 0 0 4 3.28l1.918 6.444a.5.5 0 0 0 .362.343l6.532 1.573c.52.125.507.87-.017.976L6.296 13.94z","fill":"#fff"}));
}

ChatSendIconWhite.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChatSendIconWhite;

ChatSendIconWhite.default = ChatSendIconWhite;
